import { Box, withStyles } from '@material-ui/core';
import React from 'react';
import translations from '../../translations/i18next';
import MDButton from '../MDButton/MDButton';
import { EDULAI_BLUE, EDULAI_BLUE_LIGHT, EDULAI_PURPLE } from '../../styles/styleConsts';
import Confetti from './Confetti';
import QuizUtils from '../../utils/QuizUtils/QuizUtils';
import { connect } from 'react-redux';
import { CloudDownload } from '@material-ui/icons';
import ChatIcon from '../Icons/ChatIcon';
import { Html } from '../Html/Html';

const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 8,
    paddingBottom: 20
  },
  body: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    textAlign: 'center'
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
});

/**
 * QuizFeedback Component
 *
 * Props:
 * @param {number} step - Current step number in the quiz progression
 * @param {Array} questions - Array of quiz options/questions to determine total length
 * @param {Function} onProceed - Callback function triggered when the proceed button is clicked
 */
class QuizFeedback extends React.Component {
  get messageNumber() {
    const { step, questionsTotalNumber } = this.props;
    if (QuizUtils.isFirstQuizFeedbackVisible(step, questionsTotalNumber)) return 1; // 1/4
    if (QuizUtils.isSecondQuizFeedbackVisible(step, questionsTotalNumber)) return 2; // 1/2
    if (QuizUtils.isThirdQuizFeedbackVisible(step, questionsTotalNumber)) return 3; // 3/4
    if (QuizUtils.isFourthQuizFeedbackVisible(step, questionsTotalNumber)) return 4; // semi last step
    return null;
  }

  get isLast() {
    return this.props.last || this.props.step === this.props.questionsTotalNumber;
  }

  get messageKey() {
    const prefix = 'submissions.message';
    let suffix = '';
    if (this.isLast) suffix = 'end';
    else {
      suffix = this.messageNumber;
    }
    return suffix ? `${prefix}_${suffix}` : '';
  }

  get animationType() {
    const { step, questionsTotalNumber } = this.props;
    if (QuizUtils.isFirstQuizFeedbackVisible(step, questionsTotalNumber)) return 1; // 1/4
    if (QuizUtils.isSecondQuizFeedbackVisible(step, questionsTotalNumber)) return 2; // 1/2
    if (QuizUtils.isThirdQuizFeedbackVisible(step, questionsTotalNumber)) return 7; // 3/4
    if (QuizUtils.isFourthQuizFeedbackVisible(step, questionsTotalNumber)) return 5; // semi last step
    return 6; // fireworks
  }

  downloadDigitalBadge() {
    const fileUrl = `/pdf/edulai_digital_badge_${this.props.selectedLanguage}.pdf`;
    const fileName = `edulai_digital_badge_${this.props.selectedLanguage}.pdf`;

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    return (
      <Box className={this.props.classes.root} style={{ position: 'relative', overflow: 'hidden' }}>
        <Confetti animationType={this.animationType} />
        <h2 className={this.props.classes.body}>
          <Html>{translations.t(`${this.messageKey}`)}</Html>
        </h2>
        {this.isLast && (
          <MDButton
            title={translations.t('submissions.downloadBadge')}
            backgroundColor={EDULAI_PURPLE}
            containerstyle={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClick={() => this.downloadDigitalBadge()}
            icon={<CloudDownload />}
            titleStyle={{ marginLeft: 10 }}
          />
        )}
        <MDButton
          title={this.isLast ? translations.t('submissions.buttonEnd') : translations.t('submissions.button')}
          backgroundColor={EDULAI_BLUE}
          containerstyle={{
            paddingTop: this.isLast ? 40 : 100,
            paddingBottom: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={this.props.onProceed}
          buttonStyle={{ width: 130 }}
        />
        {this.isLast && this.props.onAskAI && (
          <MDButton
            title={translations.t('chat.askAI')}
            backgroundColor={EDULAI_BLUE_LIGHT}
            containerstyle={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClick={this.props.onAskAI}
            icon={<ChatIcon />}
            titleStyle={{ marginLeft: 10 }}
          />
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedLanguage: state.utils.selectedLanguage
});

export default connect(mapStateToProps)(withStyles(styles)(QuizFeedback));
